import * as React from 'react'

const HorizontalSelectorCustom = ({ children }: { children: any }) => {
  return <div className='step-selector'>{children}</div>
}

export default HorizontalSelectorCustom



// WEBPACK FOOTER //
// ./src/components/riders/createrider/HorizontalSelectorCustom.tsx